import t from "../../../Common/utils/translation/translator";

/* eslint-disable indent */
export function colKeyToName(key) {
  switch (key) {
    // Bundle
    case "driveReference":
      return t("msizer.ui.drive_reference");
    case "motorReference":
      return t("msizer.ui.motor_reference");
    case "gearboxReference":
      return t("msizer.ui.gearbox_reference");
    case "adaptationKitRef":
      return t("msizer.ui.adaptation_kit_reference");
    case "nominalTorque":
      return t("msizer.ui.bundle_nominal_torque");
    case "nominalTorqueReserve":
      return t("msizer.ui.nominal_torque_reserve");
    case "nominalSpeed":
      return t("msizer.ui.bundle_nominal_speed");
    case "nominalSpeedReserve":
      return t("msizer.ui.nominal_speed_reserve");
    case "length":
      return t("msizer.ui.bundle_length");

    // Motor
    case "motorType":
      return t("msizer.ui.motor_filters.motor_type");
    case "inertiaRatio":
      return t("msizer.ui.inertia_ratio");
    case "bundleInertia":
      return t("msizer.ui.bundle_inertia");
    case "motorLength":
      return t("msizer.ui.motor_filters.motor_length");
    case "flangeSize":
      return t("msizer.ui.motor_filters.flange_size");
    case "shaftEnd":
      return t("msizer.ui.motor_filters.shaft_end");
    case "ipProtections":
      return t("msizer.ui.motor_filters.ip_degree_of_protection");
    case "holdingBrake":
      return t("msizer.ui.motor_filters.holding_brake");
    case "motorEncoder":
      return t("msizer.ui.motor_filters.encoder");
    case "connector":
      return t("msizer.ui.motor_filters.connector_type");
    case "nominalTorqueOfMotor":
      return t("msizer.ui.motor_filters.nominal_torque_of_motor");
    case "continuousStallTorque":
      return t("msizer.ui.motor_filters.continuous_stall_torque");
    case "peakStallTorque":
      return t("msizer.ui.motor_filters.peak_stall_torque");
    case "nominalSpeedOfMotor":
      return t("msizer.ui.motor_filters.nominal_speed_of_motor");
    case "inertiaMotor":
      return t("msizer.ui.motor_filters.inertia");
    case "motorComponentType":
      return t("msizer.ui.motor_filters.component_type");
    case "numberOfStacks":
      return t("msizer.ui.motor_filters.number_of_stacks");
    case "maximumMechanicalSpeed":
      return t("msizer.ui.motor_filters.maximum_mechanical_speed");
    case "motorSupplyVoltage":
      return t("msizer.ui.motor_filters.supply_voltage");
    case "shaftDiameter":
      return t("msizer.ui.motor_filters.shaft_diameter");
    case "shaftLength":
      return t("msizer.ui.motor_filters.shaft_length");
    case "motorWeight":
      return t("msizer.ui.motor_filters.weight");
    case "continuousStallCurrent":
      return t("msizer.ui.motor_filters.continuous_stall_current");
    case "speedFeedbackResolution":
      return t("msizer.ui.motor_filters.speed_feedback_resolution");
    case "motorOutputCurrent3SPeak":
      return t("msizer.ui.motor_filters.output_current_3s_peak");

    // Gearbox
    case "gearboxRatio":
      return t("msizer.ui.gearbox_filters.reduction_ratio");
    case "gearboxFamily":
      return t("msizer.ui.gearbox_filters.short_name");
    case "gearboxType":
      return t("msizer.ui.gearbox_filters.gearbox_type");
    case "inputDiameter":
      return t("msizer.ui.gearbox_filters.input_diameter");
    case "externalDiameter":
      return t("msizer.ui.gearbox_filters.external_diameter");
    case "gearboxEfficiency":
      return t("msizer.ui.gearbox_filters.efficiency");
    case "gearboxTorsionalBacklash":
      return t("msizer.ui.gearbox_filters.maximum_torsional_backlash");
    case "gearboxComponentType":
      return t("msizer.ui.gearbox_filters.component_type");
    case "shaftMomentOfInertia":
      return t("msizer.ui.gearbox_filters.shaft_moment_of_inertia");
    case "gearboxNetWeight":
      return t("msizer.ui.gearbox_filters.net_weight");
    case "continuousOutputTorque":
      return t("msizer.ui.gearbox_filters.continuous_output_torque");
    case "maximumOutputTorque":
      return t("msizer.ui.gearbox_filters.maximum_output_torque");
    case "gearboxIpDegreeOfProtection":
      return t("msizer.ui.gearbox_filters.ip_degree_of_protection");
    case "gearboxLength":
      return t("msizer.ui.gearbox_filters.length");

    // Drive
    case "driveType":
      return t("msizer.ui.drive_filters.drive_type");
    case "supplyVoltage":
      return t("msizer.ui.drive_filters.supply_voltage");
    case "interface":
      return t("msizer.ui.drive_filters.communication_interfaces");
    case "current":
      return t("msizer.ui.drive_filters.output_current");
    case "switchingFreq":
      return t("msizer.ui.drive_filters.switching_frequency");
    case "format":
      return t("msizer.ui.drive_filters.format");
    case "driveRangeOfProduct":
      return t("msizer.ui.drive_filters.range_of_product");
    case "driveComponentType":
      return t("msizer.ui.drive_filters.component_type");
    case "driveSupplyVoltage":
      return t("msizer.ui.drive_filters.supply_voltage");
    case "nbPhases":
      return t("msizer.ui.drive_filters.nb_phases");
    case "nominalPower":
      return t("msizer.ui.drive_filters.nominal_power");
    case "driveNetWeight":
      return t("msizer.ui.drive_filters.net_weight");
    case "driveDepth":
      return t("msizer.ui.drive_filters.depth");
    case "driveHeight":
      return t("msizer.ui.drive_filters.height");
    case "driveWidth":
      return t("msizer.ui.drive_filters.width");
    case "lineCurrent":
      return t("msizer.ui.drive_filters.line_current");
    case "driveOutputCurrent3SPeak":
      return t("msizer.ui.drive_filters.output_current_3s_peak");

    // Adaptation kit
    case "adaptationKitComponentType":
      return t("msizer.ui.adaptation_kit_attributes.component_type");
    case "separatePartDestination":
      return t("msizer.ui.adaptation_kit_attributes.separate_part_destination");
    case "adaptationKitLength":
      return t("msizer.ui.adaptation_kit_attributes.length");
    case "kitComposition":
      return t("msizer.ui.adaptation_kit.kit_composition");
    case "kitFlangeSize":
      return t("msizer.ui.adaptation_kit.flange_size");
    case "adaptationKitWeight":
      return t("msizer.ui.adaptation_kit_attributes.weight");

    // Integrated drives
    case "PRODUCT_CODE":
      return t("msizer.ui.integrated_drives_attributes.product_code");
    case "T_COMMUNICATION_INTERFACE":
      return t("msizer.ui.integrated_drives_attributes.communication_interface");
    case "TC_VOLTAGE":
      return t("msizer.ui.integrated_drives_attributes.voltage");
    case "T_OFFER_TYPE":
      return t("msizer.ui.integrated_drives_attributes.drive_type");
    case "T_ENCODER_TYPE":
      return t("msizer.ui.integrated_drives_attributes.encoder");
    case "T_NUMBER_OF_MOTOR_STACKS":
      return t("msizer.ui.integrated_drives_attributes.number_of_motor_stacks");
    case "T_HOLDING_BRAKE":
      return t("msizer.ui.integrated_drives_attributes.holding_brake");
    case "TC_LENGTH":
      return t("msizer.ui.integrated_drives_attributes.length");
    case "T_SHAFT_TYPE":
      return t("msizer.ui.integrated_drives_attributes.shaft_type");
    case "TASHAFT_TYPE":
      return t("msizer.ui.integrated_drives_attributes.shaft_type");
    case "T_MOTOR_FLANGE_SIZE":
      return t("msizer.ui.integrated_drives_attributes.motor_flange_size");
    case "TC_NOMINAL_SPEED":
      return t("msizer.ui.integrated_drives_attributes.nominal_speed");
    case "TC_NOMINAL_TORQUE":
      return t("msizer.ui.integrated_drives_attributes.nominal_torque");

    default:
      return key;
  }
}

export function colKeyToFilter(key) {
  switch (key) {
    // Motor
    // case "motorType":
    //   return t("motorType");
    case "nominalTorque":
      return t("nominalTorque");
    // case "maxTorque":
    //   return t("maxTorque");
    case "nominalSpeed":
      return t("nominalSpeed");
    // case "nominalSpeed":
    //   return t("nominalSpeed");
    case "inertiaRatio":
      return t("inertia");
    case "motorLength":
      return t("length");
    // case "flangeSize":
    //   return t("flangeSize");
    // case "shaftEnd":
    //   return t("shaftEnd");
    // case "ipDegree":
    //   return t("ipDegree");
    // case "holdingBrake":
    //   return t("holdingBrake");
    // case "motorEncoder":
    //   return t("motorEncoder");
    // case "connector":
    //   return t("connector");

    // Gearbox
    // case "gearboxManufacturer":
    //   return t("gearboxManufacturer");
    // case "gearboxType":
    //   return t("gearboxType");
    // case "gearboxRatio":
    //   return t("gearboxRatio");
    // case "precision":
    //   return t("precision");
    // case "specification":
    //   return t("specification");
    case "length":
      return t("length");

    // Drive
    // case "driveType":
    //   return t("driveType");
    case "supplyVoltage":
      return t("supplyVoltage");
    // case "interface":
    //   return t("interface");
    // case "current":
    //   return t("current");

    default:
      return t("none");
  }
}
